//bundle product option 
function custom_addtocart_fun(product){
  // console.log("function called");
  // console.log("product", product);
      fetch(`${window.routes.cartAddUrl}.js`, {
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.text())  
        .then(text => {  
          console.log("Raw Response:", text);  
          return text ? JSON.parse(text) : {};  
        })
        .then(response => {              
          console.log("Parsed Response:", response);
        })
        .catch(error => {
          console.error('Fetch Error:', error);
        })
        .finally((e) => {          
           document.documentElement.dispatchEvent(new CustomEvent("cart:build"));
           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        });        
}

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    console.log(12334)
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

 // <show-password>
 //   <a href="javascript:void(0);"class="close-icon">text</a>
 // </show-password>

customElements.define('show-password', ShowPassword);



  
function closeIcon() {
  // var cartToggleElement = document.querySelector(".header__cart-toggle");
  // var cart = document.querySelector(".mini-cart");
  // cartToggleElement.setAttribute("aria-expanded", "false");
 
  // cartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "false");
  // cart.style.maxHeight = "";
    
  // cart.setAttribute("aria-hidden", "true");
  // document.body.classList.remove("mini-cart-active");
  // document.body.classList.remove("no-mobile-scroll");
  
  // isMiniCartOpen = false;
}

// Promotion List Mobile Slider JS

const slider = document.querySelector("[data-slider]");
if (slider) {
  const track = slider.querySelector("[data-slider-track]");
  const prev = slider.querySelector("[data-slider-prev]");
  const next = slider.querySelector("[data-slider-next]");

  if (track && prev && next) {
    prev.addEventListener("click", () => {
      next.removeAttribute("disabled");

      track.scrollTo({
        left: track.scrollLeft - track.firstElementChild.offsetWidth,
        behavior: "smooth"
      });
    });

    next.addEventListener("click", () => {
      prev.removeAttribute("disabled");

      track.scrollTo({
        left: track.scrollLeft + track.firstElementChild.offsetWidth,
        behavior: "smooth"
      });
    });

    track.addEventListener("scroll", () => {
      const trackScrollWidth = track.scrollWidth;
      const trackOuterWidth = track.clientWidth;

      prev.removeAttribute("disabled");
      next.removeAttribute("disabled");

      if (track.scrollLeft <= 0) {
        prev.setAttribute("disabled", "");
      }

      if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
        next.setAttribute("disabled", "");
      }
    });
  }
}


